import React, { useEffect, useState } from "react";
import "./StackedBarchart.css";
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Label } from 'recharts';
// import { StackedBarchartFilter } from "./StackedBarchartFilter";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import Loader from '../Loader';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { Button, IconButton, Menu, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import { Tooltip as MaterialTooltip } from "@mui/material";
import { getCallAveragPractice } from "../../../actions/userActions/callAveragePract";
import { getPracticeLocations } from "../../../actions/userActions/practiceLocationAction";
import { getCities } from "../../../actions/userActions/cityAction";
import ApplyButton from "../buttons/ApplyButton";
import ResetButton from "../buttons/ResetButton";
import { Locate, LocateIcon } from "lucide-react";
import BodyMediumRegular from "../../designSystem/BodyMediumRegular";
import SingleSelect from "../../designSystem/SingleSelect";
import MultiSelect from "../../designSystem/MultiSelect";
import BodySmallRegular from "../../designSystem/BodySmallRegular";
import CustomTooltip from "../../designSystem/customtooltip";
import CustomLegend from "../../designSystem/customLegend";
import { getSubOrdinates } from "../../../actions/userActions/tasks/taskAction";
import { t } from "../../../locales/translate";



export function StackedBarchart({ chartSummaryData, loading, onChangePracticeLocation }) {
    const [appliedFilters, setAppliedFilters] = useState([]);
    const buttonLabels = {
        "today": "D",
        "this week": "W",
        "this month": "M",
        "this year": "Y",
        "custom": `${t("custom")}`,
    };
    function choosefilters(filters) {
        setAppliedFilters(filters);
    }
    const [locationCity, setLocationCity] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [customDate, setCustomDate] = useState(false);
    const [formError, setFormError] = useState({});
    const currentDate = moment();
    const [employeesName, setEmployeesName] = useState([]);
    const practiceLocationName = chartSummaryData.length > 0 ? chartSummaryData[0].practiceLocationName : null;

    // const employees = useSelector((state) => state.employees_reducer.employees);
    const [Filters, setFilters] = useState({
        practiceLocation: 0,
        employeeIds: [],
        fromDate: moment(currentDate).subtract(7, "days").format("YYYY-MM-DD"),
        toDate: moment(currentDate).format("YYYY-MM-DD"),
    });
    const [selected, setSelected] = useState({
        practiceLocation: "",
        employeeIds: [],
        fromDate: moment(currentDate).subtract(7, "days").format("YYYY-MM-DD"),
        toDate: moment(currentDate).format("YYYY-MM-DD"),
    });
    const setEmployeeNames = (array) => {
        setEmployeesName(array);
    };
    const user = JSON.parse(localStorage.getItem("user"));
    const employeeId =
        user.result[0] !== undefined ? user.result[0].user.id : false
    const practiceLocations = useSelector((state) => state.practiceLocations_reducer?.practiceLocations);
    const cities = useSelector((state) => state.cities_reducer.cities);
    const employees = useSelector((state) => state.tasks_reducer.subOrdinates);
    useEffect(() => {

        let data = [];
        employees &&
            employees !== "isLoading" &&
            employees.map((row) => {
                appliedFilters.map((row2) => {
                    if (row.id == row2) {
                        data.push(row.firstName + " " + row.lastName);
                    }
                });
            });

        setEmployeeNames(data);
    }, [employees, appliedFilters]);
    const dispatch = useDispatch();
    const [uniqueEmployees, setUniqueEmployees] = useState([]);
    const callAvgPracticeLocation = useSelector(
        (state) => state.call_avg_pract_reducer.callAvgPract
    );
    const [employeeColors, setEmployeeColors] = useState({});

    // push data in array for rechart
    const [data, setData] = useState([]);

    useEffect(() => {
        const sourceData =
            callAvgPracticeLocation &&
                callAvgPracticeLocation !== "isLoading" &&
                callAvgPracticeLocation.byPracticeLocations &&
                callAvgPracticeLocation.byPracticeLocations.length > 0
                ? callAvgPracticeLocation.byPracticeLocations
                : chartSummaryData || [];

        if (sourceData.length > 0) {
            const uniqueEmployees = [];
            const groupedData = sourceData.reduce((result, item) => {
                const date = moment(item.dateTime).format("D MMM, YY");
                const key = `${date}`;

                if (!result[key]) {
                    result[key] = { date };
                }

                if (!uniqueEmployees.includes(item.employeeName)) {
                    uniqueEmployees.push(item.employeeName);
                }

                result[key][item.employeeName] = (result[key][item.employeeName] || 0) + item.calls;

                return result;
            }, {});

            const employeeNames = new Set();
            Object.values(groupedData).forEach((item) => {
                Object.keys(item).forEach((key) => {
                    if (key !== "date") {
                        employeeNames.add(key);
                    }
                });
            });

            const outputData = Object.values(groupedData).map((item) => {
                const formattedItem = { date: item.date };
                employeeNames.forEach((employeeName) => {
                    formattedItem[employeeName] = item[employeeName] || 0;
                });
                return formattedItem;
            }).sort((a, b) => moment(a.date, "D MMM, YY").toDate() - moment(b.date, "D MMM, YY").toDate());

            setData(outputData);
            setUniqueEmployees(Array.from(employeeNames));
        }
    }, [callAvgPracticeLocation, chartSummaryData]);
    function getRandomColor() {
        const minChannelValue = 50;
        const maxChannelValue = 200;

        const randomRed = Math.floor(Math.random() * (maxChannelValue - minChannelValue + 1)) + minChannelValue;
        const randomGreen = Math.floor(Math.random() * (maxChannelValue - minChannelValue + 1)) + minChannelValue;
        const randomBlue = Math.floor(Math.random() * (maxChannelValue - minChannelValue + 1)) + minChannelValue;

        return `rgb(${randomRed}, ${randomGreen}, ${randomBlue})`;
    }
    useEffect(() => {
        if (uniqueEmployees.length > 0) {
            const newEmployeeColors = {};
            uniqueEmployees.forEach((employee) => {
                if (!employeeColors[employee]) {
                    newEmployeeColors[employee] = getRandomColor();
                }
            });
            setEmployeeColors((prevColors) => ({ ...prevColors, ...newEmployeeColors }));
        }
    }, [uniqueEmployees]);
    //

    useEffect(() => {
        const cityBody = {
            "filter": {
                "textSearch": "",
                "countryId": 1
            },
            "pageNumber": -1,
            "pageSize": 0
        }
        if (open) {
            dispatch(getCities(cityBody))
                .then(() => {
                    dispatch(getSubOrdinates(employeeId, -1, 0, ""));
                })
                .catch(error => {
                    console.error("Error fetching data:", error);
                });
        }

    }, [open]);
    useEffect(() => {
        const practiceLocationBody = {
            filter: {
                textSearch: "",
                city: locationCity
            },
            pageNumber: -1,
            pageSize: 0,
        }
        if (locationCity) {
            dispatch(getPracticeLocations(practiceLocationBody));
        }
    }, [locationCity])
    const handleApply = () => {
        if (validateForm()) {
            const body = {
                practiceLocationFilters: {
                    practiceLocation: Filters.practiceLocation ? Filters.practiceLocation : 0,
                    employeeIds: Filters.employeeIds ? Filters.employeeIds : [0],
                },
                startTime: Filters.fromDate ? Filters.fromDate : new Date().toISOString(),
                endTime: Filters.toDate ? Filters.toDate : new Date().toISOString(),
            };
            onChangePracticeLocation(body)
            dispatch(getCallAveragPractice(body));
            choosefilters(Filters.employeeIds);
            handleClose();
        }
    };

    const handleReset = () => {
        setSelected({
            practiceLocation: "",
            employeeIds: [],
            fromDate: moment(currentDate).subtract(7, "days").format("YYYY-MM-DD"),
            toDate: moment(currentDate).format("YYYY-MM-DD"),
        });
        setFilters({
            practiceLocation: 0,
            employeeIds: [],
            fromDate: moment(currentDate).subtract(7, "days").format("YYYY-MM-DD"),
            toDate: moment(currentDate).format("YYYY-MM-DD"),
        });
        setSelectedButton("this week");
    }
    //
    const validateForm = () => {
        let errors = {};
        let isValid = true;
        if (!Filters.fromDate) {
            errors.fromDate = "From date is required.";
            isValid = false;
        }
        if (!Filters.toDate) {
            errors.toDate = "To date is required.";
            isValid = false;
        }

        setFormError(errors);
        return isValid;
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const [selectedButton, setSelectedButton] = useState("this week");

    const handleToggleSelection = (event, newSelection) => {
        if (newSelection === "this week") {
            setCustomDate(false);
            const fromDate = moment().startOf("week").format("YYYY-MM-DD");
            const toDate = moment().endOf("week").format("YYYY-MM-DD");
            setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
            setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
        } else if (newSelection === "today") {
            setCustomDate(false);
            const currentDate = moment().format("YYYY-MM-DD");
            setSelected(prevValues => ({ ...prevValues, fromDate: currentDate, toDate: currentDate }));
            setFilters(prevValues => ({ ...prevValues, fromDate: currentDate, toDate: currentDate }));
        } else if (newSelection === "yesterday") {
            setCustomDate(false);
            const yesterdayDate = moment().subtract(1, "days").format("YYYY-MM-DD");
            setSelected(prevValues => ({ ...prevValues, fromDate: yesterdayDate, toDate: yesterdayDate }));
            setFilters(prevValues => ({ ...prevValues, fromDate: yesterdayDate, toDate: yesterdayDate }));
        } else if (newSelection === "last 30 days") {
            setCustomDate(false);
            const fromDate = moment().subtract(29, "days").toDate();
            const toDate = moment().toDate();
            setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
            setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
        } else if (newSelection === "this month") {
            setCustomDate(false);
            const fromDate = moment().startOf("month").toDate();
            const toDate = moment().endOf("month").toDate();
            setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
            setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
        } else if (newSelection === "last month") {
            setCustomDate(false);
            const fromDate = moment().subtract(1, "month").startOf("month").toDate();
            const toDate = moment().subtract(1, "month").endOf("month").toDate();
            setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
            setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
        } else if (newSelection === "this year") {
            setCustomDate(false);
            const fromDate = moment().startOf("year").toDate();
            const toDate = moment().endOf("year").toDate();
            setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
            setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));

        } else if (newSelection === "custom") {
            setCustomDate(true);
            setSelected(prevValues => ({ ...prevValues, fromDate: "", toDate: "" }));
            setFilters(prevValues => ({ ...prevValues, fromDate: "", toDate: "" }));
        }

        setSelectedButton(newSelection);
    };
    const handleLocationChange = (event) => {
        setSelected(prevValues => ({
            ...prevValues,
            practiceLocation: event.value,
        }));

        setFilters(prevValues => ({
            ...prevValues,
            practiceLocation: event.value,
        }));
    };
    const handleEmployeesChange = (selectedEmployees) => {

        setSelected(prevValues => ({
            ...prevValues,
            employeeIds: selectedEmployees,
        }));

        setFilters(prevValues => ({
            ...prevValues,
            employeeIds: selectedEmployees,
        }));
    };

    const handleFromDateChange = (date) => {
        const formattedDate = dayjs(date).format('YYYY-MM-DD');
        setSelected(prevValues => ({
            ...prevValues,
            fromDate: formattedDate,
        }));
        setFilters(prevValues => ({
            ...prevValues,
            fromDate: formattedDate,
        }));
    };
    const handleToDateChange = (date) => {
        const formattedDate = dayjs(date).format('YYYY-MM-DD');
        setSelected(prevValues => ({
            ...prevValues,
            toDate: formattedDate,
        }));
        setFilters(prevValues => ({
            ...prevValues,
            toDate: formattedDate,
        }));
    };
    const handleLocationCityChange = (event) => {
        setLocationCity(event.value);
    };
    const getEmployeeOptions = () => {
        return (
            employees &&
            employees !== "isLoading" &&
            employees.length !== 0 &&
            employees
                .sort((a, b) => {
                    const firstNameComparison = a.firstName.localeCompare(b.firstName);
                    return firstNameComparison !== 0
                        ? firstNameComparison
                        : a.lastName.localeCompare(b.lastName);
                })
                .map((employee) => ({
                    value: employee.id,
                    label: `${employee.firstName} ${employee.lastName}`,
                }))
        ) || [];
    };
    const getOptions = (type) => {
        if (type === "cities") {
            if (
                cities !== "isLoading" &&
                cities.length !== 0 &&
                cities.result?.[0]?.cities?.length !== 0
            ) {
                return cities.result[0].cities
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((city) => ({
                        value: city.id,
                        label: city.name
                    }));
            }
            return [];
        }
        if (type === "practiceLocations") {
            if (
                practiceLocations !== "isLoading" &&
                practiceLocations.length !== 0 &&
                practiceLocations.result &&
                practiceLocations.result.length !== 0
            ) {
                return practiceLocations?.result?.[0]?.practiceLocations
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((location) => ({
                        value: location.id,
                        label: location.name
                    }));
            }
            return [];
        }
    }
    return (
        <div className="chart-container" style={{
            backgroundColor: "#FFFFFF",
            gap: "24px",
            borderRadius: "16px",
            padding: "18px 20px",
            position: "relative",
            maxHeight: "400px"
        }}>      <div>
                <div className="row" style={{ height: '50px' }}>
                    <div className="col-10" style={{ display: "flex", alignItems: "center", gap: "8px", height: "20px" }}>
                        <LocateIcon style={{ width: "24px", height: "24px" }} />
                        <BodyMediumRegular text={t("callAverageByPracticeLocation")} style={{ fontWeight: 400 }} />
                    </div>
                    <div className="col-2 d-flex justify-content-end">
                        <MaterialTooltip title={t("applyFilters")} arrow enterDelay={500} placement="bottom">
                            <IconButton>
                                <FilterAltOutlinedIcon onClick={handleClick} />
                            </IconButton>
                        </MaterialTooltip>
                        <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            MenuListProps={{
                                'aria-labelledby': 'basic-button',
                            }}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            PaperProps={{
                                style: {
                                    width: "640px",
                                    borderRadius: "4px",
                                    background: "#FFFFFF",
                                    boxShadow: "0px 11px 15px -7px #00000033",
                                },
                            }}
                        >
                            <div className="row" style={{
                                padding: "16px 24px 16px 24px",
                                justify: "space-between",
                                display: "flex",
                                gap: "24px"
                            }}>
                                <div className="col-12 d-flex ml-2">
                                    <BodyMediumRegular text={t("applyFilters")} />
                                    <MaterialTooltip title="Close Filter" arrow>
                                        <CloseIcon style={{ marginLeft: "auto", cursor: "pointer" }} onClick={handleClose} />
                                    </MaterialTooltip>
                                </div>
                            </div>
                            <div className="row" style={{
                                gap: "24px",
                                borderBottom: "1px solid #0000001F",
                                padding: "24px 16px 24px 16px",
                                alignItems: "center"
                            }}>
                                <div className="row" style={{ gap: "16px" }}>
                                    <div className="col-12 d-flex justify-content-center align-items-center" style={{ height: "48px" }}>
                                        <ToggleButtonGroup
                                            exclusive
                                            value={selectedButton}
                                            onChange={handleToggleSelection}
                                            aria-label="button group"
                                            style={{
                                                width: "100%",
                                                height: "40px",
                                                gap: "12px",
                                                borderRadius: "6px",
                                                padding: "4px 8px",
                                                backgroundColor: "#f9fafb",
                                                display: "flex",
                                                justifyContent: "space-evenly",
                                                alignItems: "center",
                                            }}
                                        >

                                            {["today", "this week", "this month", "this year", "custom"].map((value) => (
                                                <ToggleButton
                                                    key={value}
                                                    value={value}
                                                    style={{
                                                        minWidth: "34px",
                                                        height: "34px",
                                                        padding: "4px 12px",
                                                        borderRadius: "6px",
                                                        textTransform: "none",
                                                        border: "none",
                                                        backgroundColor: selectedButton === value ? "#FFFFFF" : "inherit",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <BodyMediumRegular text={buttonLabels[value]} />
                                                </ToggleButton>
                                            ))}

                                        </ToggleButtonGroup>
                                    </div>
                                    <div className="col-12 d-flex" style={{
                                        height: "56px",
                                    }}>
                                        <div className="col-6">
                                            <div style={{ marginBottom: "6px" }}>
                                                <BodySmallRegular text={t("from")} />
                                            </div>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker

                                                    valueType="date"
                                                    value={selected.fromDate && selected.fromDate.length != 0 ? dayjs(selected.fromDate) : null}
                                                    onChange={handleFromDateChange}
                                                    disabled={!customDate}
                                                    renderInput={(params) => <TextField fullWidth {...params} />}
                                                    sx={{
                                                        width: "100%",
                                                        "& .MuiOutlinedInput-root": {
                                                            height: "40px",
                                                            padding: "0",
                                                            boxSizing: "border-box",
                                                            backgroundColor: "transparent",
                                                            border: "1px solid #E0E0E0",
                                                            borderRadius: "60px",
                                                            "& .MuiOutlinedInput-notchedOutline": {
                                                                border: "none",
                                                            },
                                                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                                                border: "none",
                                                            },
                                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                border: "none",
                                                            },
                                                        },
                                                        "& .MuiInputBase-input": {
                                                            height: "32px",
                                                            padding: "0px 8px",
                                                            fontSize: "14px",
                                                        },
                                                        "& .MuiIconButton-root": {
                                                            padding: "20px",
                                                        },
                                                    }}
                                                />
                                            </LocalizationProvider>
                                            {formError.fromDate && (
                                                <span style={{ color: "red" }}>{formError.fromDate}</span>
                                            )}
                                        </div>
                                        <div className="col-6">
                                            <div style={{ marginBottom: "6px" }}>
                                                <BodySmallRegular text={t("to")} />
                                            </div>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>

                                                <DatePicker

                                                    valueType="date"
                                                    value={selected.toDate && selected.toDate.length != 0 ? dayjs(selected.toDate) : null}
                                                    onChange={handleToDateChange}
                                                    disabled={!customDate}
                                                    renderInput={(params) => <TextField fullWidth {...params} />}
                                                    sx={{
                                                        width: "100%",
                                                        "& .MuiOutlinedInput-root": {
                                                            height: "40px",
                                                            padding: "0",
                                                            boxSizing: "border-box",
                                                            backgroundColor: "transparent",
                                                            border: "1px solid #E0E0E0",
                                                            borderRadius: "60px",
                                                            "& .MuiOutlinedInput-notchedOutline": {
                                                                border: "none",
                                                            },
                                                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                                                border: "none",
                                                            },
                                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                border: "none",
                                                            },
                                                        },
                                                        "& .MuiInputBase-input": {
                                                            height: "32px",
                                                            padding: "0px 8px",
                                                            fontSize: "14px",
                                                        },
                                                        "& .MuiIconButton-root": {
                                                            padding: "20px",
                                                        },
                                                    }}
                                                />
                                            </LocalizationProvider>
                                            {formError.toDate && (
                                                <span style={{ color: "red" }}>{formError.toDate}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{ gap: "16px" }}>
                                    <div className="col-12 d-flex" >
                                        <div className="col">
                                            <SingleSelect
                                                label={t("city")}
                                                isSearchable
                                                secondaryLabel
                                                error={locationCity.city}
                                                iconEnd
                                                onChange={handleLocationCityChange}
                                                value={locationCity}
                                                placeholder={t("city")}
                                                options={(cities &&
                                                    cities !== "isLoading" &&
                                                    cities.length !== 0 && cities.result?.[0]?.cities &&
                                                    cities.result?.[0]?.cities.length !== 0)
                                                    && getOptions("cities")}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{ gap: "16px" }}>
                                    <div className="col-12 d-flex" >
                                        <div className="col-6">
                                            <SingleSelect
                                                label={t("practiceLocation")}
                                                isSearchable
                                                secondaryLabel
                                                iconEnd

                                                onChange={handleLocationChange}
                                                value={selected.practiceLocation}
                                                placeholder={t("practiceLocation")}
                                                options={getOptions("practiceLocations")}
                                            />

                                        </div>
                                        <div className="col-6">
                                            <MultiSelect
                                                isSearchable
                                                onChange={handleEmployeesChange}
                                                value={selected?.employeeIds || []}
                                                label={t("employee")}
                                                options={getEmployeeOptions()}
                                            />

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mr-4" style={{
                                padding: "16px 24px 16px 24px",
                                gap: "8px",
                                display: "flex",
                                justifyContent: "flex-end"
                            }}>
                                <button
                                    type="submit"
                                    className="primary-button"
                                    disabled={false}
                                    onClick={handleApply}
                                >
                                    <span className="button-content">
                                        <p className="button-text save">{t("apply")}</p>
                                    </span>
                                </button>
                                <button
                                    className="cancel-button"
                                    type="button"
                                    onClick={handleReset}

                                >
                                    <span className="button-content">
                                        <p className="button-text">{t("reset")}</p>
                                    </span>
                                </button>
                            </div>

                        </Menu>
                    </div>
                    <div className="row">
                        <div className="col-12" style={{ height: '30px' }}>
                            <p style={{ margin: "8px", maxHeight: '24px', fontFamily: "inter", fontWeight: "500", fontSize: "16px", lineHeight: "24px" }}>
                                {callAvgPracticeLocation.byPracticeLocations?.[0]?.practiceLocationName}
                            </p>
                        </div>
                    </div>

                    {/* <div className="row" style={{ marginTop: '8px' }}>
                        <div className="col-12 d-flex" style={{ width: '480px', height: '24px' }}>
                            {employeesName &&
                                employeesName.map((pn) => <span className="mr-2" style={{ paddingLeft: '4px', paddingBottom: '3px', paddingRight: '4px', borderRadius: '100px', border: '1px solid #00000014', height: '24px', width: "" }} key={pn}>{pn}</span>)}
                        </div>
                    </div> */}
                </div>
            </div>

            <div className="graph-container" style={{ height: '320px' }}>
                {(callAvgPracticeLocation === "isLoading") && (
                    <div className="col-12 d-flex justify-content-center">
                        <Loader colored={true} />
                    </div>
                )}
                {!loading &&
                    practiceLocationName &&
                    !(
                        callAvgPracticeLocation &&
                        callAvgPracticeLocation.byPracticeLocations
                    ) && (
                        <div style={{ display: "flex", alignItems: "center", textAlign: "left" }}>
                            <span
                                style={{
                                    width: "12px",
                                    height: "12px",
                                    backgroundColor: "#5A55DF",
                                    borderRadius: "4px",
                                    marginRight: "8px",
                                }}
                            ></span>
                            <BodyMediumRegular text={practiceLocationName} />
                        </div>
                    )}

                {callAvgPracticeLocation !== "isLoading" && !loading && data.length > 0 ? (
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={data} margin={{ top: 24, right: 10, left: 2, bottom: 5 }}>
                            <CartesianGrid vertical={false} />
                            <XAxis dataKey="date" tickLine={false} tickMargin={10} axisLine={false} />
                            <Tooltip content={<CustomTooltip />} />
                            <Legend content={<CustomLegend />} />
                            {uniqueEmployees.map((employee, index) => (
                                <Bar key={index} dataKey={employee} stackId="a" radius={[4, 4, 4, 4]} fill={employeeColors[employee]} />
                            ))}
                        </BarChart>
                    </ResponsiveContainer>
                ) : null}
                {callAvgPracticeLocation !== "isLoading" && !loading && data.length === 0 && (
                    <div style={{ height: "240px", border: "1px solid grey", display: "flex", alignItems: "center", justifyContent: "center", margin: "24px 10px 5px 20px" }}>
                        <div className="col-12 d-flex justify-content-center">
                            {t("noDataMessage")}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
